<template>
  <SideNav />
  <header>
    <div class="page-header min-vh-50 bg-gradient-dark" />
    <div class="bg-gradient-warning position-relative mx-xxl-8 mx-xl-4 mx-lg-3 mx-3 pt-6 pb-3 z-index-2 border-radius-xl mt-n12 overflow-hidden">
      <img
        src="assets/img/shapes/pattern-lines.svg"
        alt="pattern-lines"
        class="position-absolute opacity-6 start-0 top-0 w-100"
        loading="lazy"
      >
      <div class="container position-relative">
        <div class="row justify-content-center align-items-center">
          <div class="col-lg-5 col-md-7 text-start py-sm-5 me-auto position-relative">
            <div class="position-relative">
              <h2 class="text-white mt-sm-0 mb-3">
                Tron Edu 系列產品
              </h2>
              <p class="lead text-white mb-3">
                TronEdu EMS Essentials Plus<br>TronEdu Exam Editor
              </p>
              <!--
		<a href="https://cloudraise.com/support/download?prd=CrStreamConvert2.0&fn=CloudRaiseCRStreamConverter&v=latest&ext=exe" target="_blank">
              <button type="button" class="btn bg-gradient-dark btn-lg me-3"><i class="material-icons me-2">note_alt</i>題目轉檔工具下載</button><br>
		</a>-->
              <button
                type="button"
                class="btn bg-gradient-dark btn-lg me-3"
              >
                <i class="material-icons me-2">play_circle</i>系統教學影片下載
              </button><br>
              <a
                href="https://download.cloudraise.com/support/download?prd=TronEdu2.0&fn=TronEduEMSUserGuild&v=latest&ext=pdf"
                target="_blank"
              >
                <button
                  type="button"
                  class="btn bg-gradient-dark btn-lg me-3"
                ><i class="material-icons me-2">menu_book</i>教學手冊下載</button><br>
              </a>
              <a
                href="https://download.cloudraise.com/support/download?prd=TronEdu2.0&fn=TronEduEMSEssentialsPlusDM&v=latest&ext=pdf"
                target="_blank"
              >
                <button
                  type="button"
                  class="btn bg-gradient-dark btn-lg me-3"
                ><i class="material-icons me-2">description</i>DM下載</button><br>
              </a>
              <a
                href="https://download.cloudraise.com/support/download?prd=TronEduExamEditor2.0&fn=CloudRaiseTronEduExamEditor&v=latest&ext=exe"
                target="_blank"
              >
                <button
                  type="button"
                  class="btn bg-gradient-dark btn-lg"
                ><i class="material-icons me-2">school</i>教育局題目轉檔工具下載</button><br>
              </a>         
            </div>
          </div>
          <div class="col-lg-7 position-absolute start-50 end-0 me-n12 w-75">
            <img
              class="w-100 d-md-block d-none"
              src="assets/img/macbook-2.png"
              alt="macbook"
              loading="lazy"
            >
          </div>
        </div>
      </div>
    </div>
  </header>
  <div class="pt-5 pb-5 pb-lg-6 container px-0">
    <!--
    <div class="text-center">
    <button type="button" class="btn bg-gradient-dark btn-lg me-3">教育局題目轉檔工具下載</button>
    <button type="button" class="btn bg-gradient-dark btn-lg me-3">題目轉檔工具下載</button>
    <button type="button" class="btn bg-gradient-dark btn-lg">系統教學影片下載</button>
    </div>
-->

    <div class="p-3 info-hover-warning text-center mb-4 mt-8">
      <div class="icon icon-shape bg-gradient-warning shadow icon-shape-circle text-warning">
        <i class="fa fa-pen  opacity-10" />
      </div>
    </div>
    <h4 class="mb-4 text-center mb-6">
      TronEdu EMS Essentials Plus：<br class="d-md-none">雲端題庫管理必要型產品包
    </h4>
    <div class="row align-items-center mx-0">
      <div class="d-lg-none">
        <div class="border border-warning text-warning p-3 rounded mb-4">
          <p>Cloud Raise TronEdu EMS Essentials Plus 優勢：</p>
          <ul class="mb-0">
            <li class="mb-3">
              支援Microsoft Office Word 所見即所得編輯，雲端同步內容排版
            </li>
            <li>提供Word、SVG、PNG、XML及JSON等多種檔案格式</li>
          </ul>
        </div>
      </div>
      <div
        class="mx-auto col-md-6 col-lg-6 order-2 order-md-1"
        id="EXAM"
      >
        <div class="border border-warning text-warning p-3 rounded mb-4 d-none d-lg-block">
          <p>Cloud Raise TronEdu EMS Essentials Plus 優勢：</p>
          <ul class="mb-0">
            <li class="mb-3">
              支援Microsoft Office Word 所見即所得編輯，雲端同步內容排版
            </li>
            <li>提供Word、SVG、PNG、XML及JSON等多種檔案格式</li>
          </ul>
        </div>
        <p class="text-dark lh-lg">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;TronEdu EMS Essentials Plus -
          雲端題庫管理必要型產品包是分別由 TronEdu Exam Editor 2.0 - 題庫編輯軟體工具與 TronEdu Exam Platform 2.0 -
          題庫雲端服務系統，依單位必要需求來包裝的套餐產品，它是集結各大教育集團、地方政府、學校在各種雲端命題、出卷、考試、分析、診斷等資訊應用服務需求，基於以使用者為中心的友善操作而出發的產品。
          <br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          獨家「跨載具命題系統」專利技術，憑藉多年來各家教育集團、教育機構、地方政府、學校編輯人員、各領域教師的編輯操作使用經驗，解決現行小學、國中、高中的全科、全版編輯及全載具解析度問題。
          採用 Microsoft Word 做為主要的編輯工具，並可同步題庫內容到雲端，大幅度的降低雲端題庫各種應用整合風險及成本，是一套成熟且具備豐富技術know-how的穩定產品。
          <br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Cloud Raise累積數年豐富的 K12
          教育科技整合經驗，設計出最符合出題和編輯人員使用習慣的編輯管理工具及雲端資料中心服務系統，採用標準化的RESTful API風格架構和容器化微服務架構，支援全載具（手機、 平板、 電腦、
          智慧電視）等環境，讓使用者可以運用本系統快速的建置、擴展高效穩定的題庫應用相關平台和服務。
        </p>
      </div>
      <div class="col-10 col-md-6 col-lg-4 col-xxl-3 order-1 order-md-2 mb-5 mb-md-0 mx-auto">
        <img
          src="assets/img/news-1.jpg"
          class="img-fluid rounded shadow-lg"
        >
      </div>
    </div>

    <section class="pt-5 pt-lg-8">
      <div class="container px-0">
        <div class="row align-items-center mx-0">
          <div class="col-9 col-md-5 col-lg-4 mx-auto">
            <img
              src="assets/img/ccc.png"
              class="img-fluid"
            >
          </div>
          <div class="col-md-7 col-lg-6 mt-lg-0 mt-5 ps-lg-0 ps-0">
            <div class="p-3 info-horizontal">
              <div class="icon icon-shape  bg-gradient-warning text-center rounded-pill shadow-none">
                <i class="fas fa-spell-check opacity-10 text-lg" />
              </div>
              <div class="description ps-3">
                <p>Cloud Raise TronEdu Exam Editor 2.0 規格建議：</p>
                <ul class="mb-0">
                  <li class="mb-3">
                    建議使用 Windows 7 以上版本作業系統
                  </li>
                  <li>建議使用 Microsoft Office Word 2013 以上的版本</li>
                </ul>
              </div>
            </div>

            <div class="p-3 info-horizontal">
              <div
                class="icon icon-shape  bg-gradient-warning text-center rounded-pill"
                s
              >
                <i class="fas fa-code opacity-10" />
              </div>
              <div class="description ps-3">
                <p>Cloud Raise TronEdu Exam Platform 2.0 規格建議：</p>
                <ul class="mb-0">
                  <li class="mb-3">
                    建議使用 ubuntu 20.04 以上的版本
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--
      <div class="p-3 info-hover-warning text-center mb-4 mt-8">
        <div class="icon icon-shape bg-gradient-primary shadow icon-shape-circle text-primary">
          <i class="fa fa-pen  opacity-10"></i>
        </div>
      </div>
      <h4 class="mb-4 text-center mb-6">創益題產品DM</h4>    
        <div class="row">
        <div class="col-lg-6">
                <img class="img-fluid rounded shadow-lg" src="assets/img/tronedudm1.jpg">
        </div>
        <div class="col-lg-6 mt-5 mt-lg-0">
        <img class="img-fluid rounded shadow-lg" src="assets/img/tronedudm2.jpg">
    </div>
    </div>
-->
  </div>
  <!-- -------- START Features w/ 4 infos - just colored icons -------- -->

  <footer class="footer mt-5">
    <div class="container">
      <div class=" row align-items-center">
        <div class="col-md-6 mb-md-4 me-auto">
          <div class="d-none d-md-block">
            <a 
              href="javascript:;"
              @click="goToPage('/')"
            >
              <img
                src="assets/img/logo4.svg"
                class="mb-3"
                style="width: 160px;"
              >
            </a>
          </div>
        </div>

        <div class="col-md-6 mb-md-4 ms-auto text-center text-md-end">
          <a class="mb-3"><img
            src="assets/img/logo4.svg"
            style="width: 160px;"
            class="mb-3 d-md-none"
          ></a>

          <p class="mb-1">
            service@cloudraise.com
          </p>
          <p class="mb-1">
            新北市三重區重新路五段609巷14號5樓之3
          </p>
          <p class="mb-1">
            02-29992891
          </p>
        </div>
        <div class="col-12">
          <div class="text-center">
            <p class="text-dark my-2 my-md-4 text-sm font-weight-normal">
              Copyright ©
              2023
              by Cloud Raise Technology.
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
/* eslint-disable import/no-absolute-path */
// eslint-disable-next-line import/no-unresolved
import { config } from '@/include/config';
import {
  h,
  ref,
  toRefs,
  reactive,
  watch,
  inject,
  onMounted,
  onBeforeUpdate,
  onUpdated
} from 'vue';
import { oltConsole, oAA , oAuth, oApiError , oFrame } from '@/lib/oltModule/initOltVue3';
import { SideNav , Header , ProductHeader , Footer } from '@/components/Frame';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';

export default {
  name: 'App',
  components: {
    SideNav,
    //Header,
    //ProductHeader,
    //NavBar,
    // Settings,
    //Footer,
  },
  setup() {

    /**
     *  swal start
     */
    const swal = inject('$swal');
    /**
     *  swal end
     */

    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    const nid = ref();

    //console.log('router.currentRoute.value : ', router.currentRoute.value.query);
    /*
    if(router.currentRoute.value.query.nid == null || router.currentRoute.value.query.nid == '' ){
      swal.fire({
        icon:'error',
        html:'路徑錯誤！！',
        buttonsStyling: true,
        confirmButtonClass: 'md-button md-success',
        //confirmButtonText:t('messages.confirm_button'),
      }).then( result => {
        if (result.value) {
          //console.log('result : ' , result);
          //emit('addCallBack');
          //router.go(-1);
          goToPage('/');
        }
      });
    }
	*/
    nid.value= router.currentRoute.value.query.nid ; 

    //console.log('nid' , nid.value);

    onMounted(async () => {
      chkLogin();
    });
    // Reload MDInput End

    onUpdated(async () => {
      // 修改 VUE 時 必需全部強制關閉 Modals 
      // eslint-disable-next-line no-undef
      //await oAdminFrame.closeAllModals() ;
    }) ;
    function goToPage(page){
      router.push( { path: page } );
    }


    function chkLogin(){
      let isLogin = oAuth.isLogin(store);

      if(!isLogin){
        //router.push({ path: '/AuthPage/SignIn' });
      }
    }

    return {
      hiddenHeader:false,
      // api setting
      setDebugMode: true,
      apiDebug: false,
      apiName: '',
      perPage: 3, //筆數
      pageMode: true,
      perPageOptions: [5, 10, 25, 50, 75, 100],
      // data
      userInfo:{coin:0 , point:0},
      token:null,
      nid,
      // function
      goToPage,
      chkLogin,
    };
  },
  created() {
  },
  mounted() {
    oFrame.initMD();
  },
  methods: {
  }
};
</script>
